// Flag resume with no experience *****************************************************************
// pathname: /v1/resume/no-experience
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';

/**
 * @description SWR mutation: POST no experience.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 */
export const useSwrResumeNoExperience = (locale: string = 'ro', successCallback?: () => void) => {
  const {
    data, error, trigger, reset,
  } = useSwrMutationApi({
    url: '/v1/resume/no-experience',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
    },
  });

  return {
    data,
    error,
    trigger,
    reset,
  };
};

